export const getAuthUser = (state) => state.auth.authUser;
export const getToken = (state) => state.auth.token;